/**
 * Form component for editing playlist metadata (title, service info, users)
 */
function MetadataForm({ title, setTitle, service, serviceId, users, isNew, saving, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className='mb-6 rounded border p-4'>
      <h3 className='mb-3 text-lg font-semibold'>Playlist Details</h3>

      <div className='space-y-4'>
        <div>
          <label className='mb-1 block'>Title</label>
          <input
            type='text'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className='w-full rounded border p-2'
            required
          />
        </div>

        {!isNew && (
          <>
            <div className='grid grid-cols-2 gap-4'>
              <div>
                <label className='mb-1 block'>Service</label>
                <input
                  type='text'
                  value={service}
                  readOnly
                  className='bg-gray-50 w-full rounded border p-2'
                />
              </div>

              <div>
                <label className='mb-1 block'>Service ID</label>
                <input
                  type='text'
                  value={serviceId}
                  readOnly
                  className='bg-gray-50 w-full rounded border p-2'
                />
              </div>
            </div>

            <div>
              <label className='mb-1 block'>Users</label>
              <div className='bg-gray-50 min-h-[40px] rounded border p-2'>
                {users.length > 0 ? (
                  <div className='flex flex-wrap gap-2'>
                    {users.map((user) => (
                      <span
                        key={user.id}
                        className='bg-blue-100 text-blue-800 rounded px-2 py-1 text-sm'
                      >
                        {user.username} ({user.email})
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className='text-gray-500'>No users have this playlist</span>
                )}
              </div>
            </div>
          </>
        )}

        <div>
          <button
            type='submit'
            className='bg-blue-500 hover:bg-blue-600 text-white rounded px-4 py-2'
            disabled={saving}
          >
            {saving ? 'Saving...' : isNew ? 'Create Playlist' : 'Update Playlist'}
          </button>
        </div>
      </div>
    </form>
  )
}

export default MetadataForm
